var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#079455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7953 9.8542L13.2487 19.0675L10.7153 16.3609C10.2487 15.9209 9.51534 15.8942 8.982 16.2675C8.462 16.6542 8.31534 17.3342 8.63534 17.8809L11.6353 22.7609C11.9287 23.2142 12.4353 23.4942 13.0087 23.4942C13.5553 23.4942 14.0753 23.2142 14.3687 22.7609C14.8487 22.1342 24.0087 11.2142 24.0087 11.2142C25.2087 9.98753 23.7553 8.90753 22.7953 9.84086V9.8542Z",
    fill: "#F6FEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.08b0277752a99b388a232bcd8a6a14c3.svg";
export { ForwardRef as ReactComponent };